module.exports = __webpack_public_path__ + "img/logo_font_bottom.0770b83d.svg";